import script from "./SimplePDFViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimplePDFViewer.vue?vue&type=script&setup=true&lang=ts"

import "./SimplePDFViewer.vue?vue&type=style&index=0&id=3a3352bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a3352bf"]])

export default __exports__